// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_048c9ff"};